import axios from "axios";
import mock from "../pages/EmployeeFace/List/mock";
import config from "../config";

export default {
  namespaced: true,
  state: {
    employeefaces: [],
    images: [],
    isReceiving: false,
    isUpdating: false,
    isDeleting: false,
    idToDelete: null,
    employeefacesMessage: ''
  },
  mutations: {
    RECEIVED_EMPLOYEE_FACES(state, payload) {
      state.employeefaces = payload;
      state.isReceiving = false;
    },
    RECEIVING_EMPLOYEE_FACES(state) {
      state.isReceiving = true;
    },
    RECEIVED_EMPLOYEE_FACE(state, payload) {
      state = Object.assign(state, {
        employeefaces: [...state.employeefaces, payload],
        isReceiving: false,
      })
    },
    RECEIVING_EMPLOYEE_FACE(state) {
      state.isReceiving = true;
    },
    UPDATED_EMPLOYEE_FACE(state, payload) {
      let index = state.employeefaces.findIndex(employeeface => employeeface._id === payload._id);
      state = Object.assign(state, {
        employeefaces: state.employeefaces.map((employeeface, i) => {
          if (i === index) {
            return Object.assign({}, employeeface, payload);
          }
          return employeeface;
        }),
        isUpdating: false,
        employeefacesMessage: 'EmployeeFaces has been updating!',
      })
    },
    UPDATING_EMPLOYEE_FACE(state) {
      state.isUpdating = true;
    },
    DELETED_EMPLOYEE_FACE(state, payload) {
      let indexToDelete = state.employeefaces.findIndex(employeeface => employeeface._id === payload._id);
      let employeefaces = [...state.employeefaces];
      employeefaces.splice(indexToDelete, 1);
      state = Object.assign(state, {
        employeefaces: [...employeefaces],
        isDeleting: false,
        idToDelete: null,
        employeefacesMessage: 'EmployeeFace has been Deleted!',
      });
    },
    DELETING_EMPLOYEE_FACE(state, payload) {
      state.isDeleting = true;
      state.idToDelete = payload.id;
    },
  },
  actions: {
    getEmployeeFacesRequest({dispatch}) {
      dispatch("receivingEmployeeFaces");
      var token = localStorage.getItem('token');
      var url = 'https://api.tradexc.com:3000/get/employeefaces';
      var header = {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + token
      };
      var get = {
        method: "get",
        url: url,
        headers: header,
      };
      axios(get).then(res => {
        dispatch("receiveEmployeeFaces", res.data);
      })
    },
    loadEmployeeFaceRequest({dispatch}, id) {
      // We check if app runs with backend mode
      if (!config.isBackend) {
        dispatch("receiveEmployeeFace", mock.find(arr => arr.id === id));
      }
      else {
        dispatch("receivingEmployeeFace");
        axios.get('/employeefaces/' + id).then(res => {
          dispatch("receiveEmployeeFace", res.data);
        })
      }
    },
    updateEmployeeFaceRequest({dispatch}, payload) {
      dispatch("updatingEmployeeFace");
      var id = payload._id;
      delete payload['_id'];
      var token = localStorage.getItem('token');
      var url = 'https://api.tradexc.com:3000/update/employeeface/' + id;
      var header = {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + token
      };
      var post = {
        method: "post",
        url: url,
        headers: header,
        data: payload,
      };

      axios(post)
      .then(function (res) {
        dispatch("updateEmployeeFace", res.data);
      })
      .catch((error) => {
        console.error('Error:', error);
        this.alertmessage = error;
      });
    },
    updateEmployeeFaceImageRequest({dispatch}, payload) {
      dispatch("updatingEmployeeFace");
      var data;
      var header;
      var token = localStorage.getItem('token');
      var id = payload._id;
      delete payload['_id'];
      var url = 'https://api.tradexc.com:3000/update/employeeface/image/' + id;
      data = new FormData();
      data.append('image', payload.employeefaceimage, payload.imagename); 
      delete payload['employeefaceimage'];
      for (let x in payload) {
        data.append(x, payload[x]);
      }
      header = {
        'Content-Type': 'multipart/form-data',
        'Authorization': 'Bearer ' + token
      };

      var post = {
        method: "post",
        url: url,
        headers: header,
        data: data,
      };

      axios(post)
      .then(function (res) {
        dispatch("updateEmployeeFace", res.data);
      })
      .catch((error) => {
        console.error('Error:', error);
        this.alertmessage = error;
      });
    },
    createEmployeeFaceRequest({dispatch}, payload) {
      dispatch("receivingEmployeeFaces");
      var url;
      var data;
      var header;
      var token = localStorage.getItem('token');
      url = 'https://api.tradexc.com:3000/insert/employeeface';
      data = payload;
      header = {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + token
      };

      var post = {
        method: "post",
        url: url,
        headers: header,
        data: data,
      };
      axios(post)
      .then(function (res) {
        dispatch("receiveEmployeeFace", res.data);
      })
      .catch((error) => {
        console.error('Error:', error);
        this.alertmessage = error;
      });	
    },
    deleteEmployeeFaceRequest({dispatch}, payload) {
      var token = localStorage.getItem('token');
      let url = 'https://api.tradexc.com:3000/delete/employeeface/' + payload._id;
      let data = payload;
      let headers = {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + token
      };

      var del = {
        method: "delete",
        url: url,
        headers: headers,
        data: data,
      };
      dispatch("deletingEmployeeFace", payload);
      axios(del).then(() => {
        dispatch("deleteEmployeeFace", {_id: payload._id});
      })
    },
    receiveEmployeeFaces({commit}, payload) {
      commit("RECEIVED_EMPLOYEE_FACES", payload)
    },
    receivingEmployeeFaces({commit}) {
      commit("RECEIVING_EMPLOYEE_FACES")
    },
    receiveEmployeeFace({commit}, payload) {
      commit("RECEIVED_EMPLOYEE_FACE", payload)
    },
    receivingEmployeeFace({commit}) {
      commit("RECEIVING_EMPLOYEE_FACE")
    },
    updateEmployeeFace({commit}, payload) {
      commit("UPDATED_EMPLOYEE_FACE", payload)
    },
    updatingEmployeeFace({commit}) {
      commit("UPDATING_EMPLOYEE_FACE")
    },
    deleteEmployeeFace({commit}, payload) {
      commit("DELETED_EMPLOYEE_FACE", payload)
    },
    deletingEmployeeFace({commit}, payload) {
      commit("DELETING_EMPLOYEE_FACE", payload)
    }
  },
};
